export default __webpack_public_path__ + "static/media/arcadefx.0b23aa05.mp3";